import { GoogleRatingLine } from "./GoogleRating";
import { Link } from "@tanstack/react-router";
import { Phone, ShieldCheck } from "lucide-react";
import { BUSINESS } from "./constants";
import { CTASection } from "./CTASection";
import { ContactForm } from "./ContactForm";

export function PageHero({ eyebrow, title, subtitle, showRating }: { eyebrow?: string; title: string; subtitle?: string; showRating?: boolean }) {
  return (
    <section className="storm-bg text-brand-foreground relative overflow-hidden">
      <div className="absolute inset-0 opacity-20 bg-[radial-gradient(circle_at_20%_10%,white,transparent_40%)]" />
      <div className="relative mx-auto max-w-7xl px-4 py-14 md:py-20">
        {eyebrow && <div className="text-sm font-semibold uppercase tracking-wider text-cta mb-3">{eyebrow}</div>}
        <h1 className="text-4xl md:text-5xl lg:text-6xl font-display font-bold max-w-4xl">{title}</h1>
        {showRating && <div className="mt-3"><GoogleRatingLine /></div>}
        {subtitle && <p className="mt-4 text-lg md:text-xl opacity-85 max-w-3xl">{subtitle}</p>}
        <div className="mt-7 flex flex-col sm:flex-row gap-3">
          <a href={BUSINESS.phoneHref} className="btn-cta w-full sm:w-auto">
            <Phone className="size-5" /> Call {BUSINESS.phone}
          </a>
          <Link to="/contact" className="btn-outline-light w-full sm:w-auto">Schedule My Free Roof Inspection</Link>
        </div>
        <div className="mt-6 flex flex-wrap items-center gap-x-5 gap-y-2 text-sm opacity-85">
          <span className="inline-flex items-center gap-1.5"><ShieldCheck className="size-4" /> {BUSINESS.license}</span>
          <span>· Licensed & Insured</span>
          <span>· Family-Owned</span>
        </div>
      </div>
    </section>
  );
}

export function ServicePageBody({
  title, service, children,
}: { title: string; service: string; children: React.ReactNode }) {
  return (
    <>
      <div className="mx-auto max-w-7xl px-4 py-12 md:py-16 grid gap-10 lg:grid-cols-3">
        <article className="lg:col-span-2 prose prose-slate max-w-none">
          {children}
        </article>
        <aside className="lg:col-span-1">
          <div className="lg:sticky lg:top-24">
            <h2 className="font-display text-2xl font-bold mb-3">Request {title}</h2>
            <p className="text-sm text-muted-foreground mb-4">Free Roof Inspection & Estimate — honest, no-pressure quotes from a local family-owned roofer.</p>
            <ContactForm defaultService={service} formName={`service_${service.toLowerCase().replace(/[^a-z0-9]+/g, "_").replace(/^_|_$/g, "")}`} />
          </div>
        </aside>
      </div>
      <CTASection />
    </>
  );
}
